<template>
  <div id="wrapper" class="admin login">
    <div id="shade"></div>
    <div id="header">
      <a class="home">home</a>
    </div>
    <div id="login" v-loading="isSending">
      <span class="error_msg_top" v-show="errors.nonFieldErrors.length">{{ errors.nonFieldErrors[0] }}</span>
      <form>
        <fieldset>
          <input
            class="txt"
            id="id_username"
            maxlength="254"
            name="username"
            v-model="username"
            placeholder="ID"
            @keyup.enter="submit"
            tabindex="1"
            type="text" />
          <span class="error_msg" v-show="errors.username.length">{{ errors.username[0] }}</span>
        </fieldset>
        <fieldset>
          <input
            class="txt"
            id="id_password"
            name="password"
            placeholder="パスワード"
            type="password"
            @keyup.enter="submit"
            tabindex="2"
            v-model="password" />
          <span class="error_msg" v-show="errors.password.length">{{ errors.password[0] }}</span>
        </fieldset>
        <fieldset>
          <input
            class="txt"
            id="id_license"
            maxlength="100"
            name="license"
            placeholder="ライセンスキー"
            @keyup.enter="submit"
            type="text"
            tabindex="3"
            v-model="license" />
          <span class="error_msg" v-show="errors.license.length">{{ errors.license[0] }}</span>
        </fieldset>
        <fieldset>
          <input v-model="rememberMe" id="id_remember_me" name="remember_me" type="checkbox" /> ログイン状態を保存する

        </fieldset>
        <input type="button" @click="submit" name="submit" id="submit" value="ログイン" />
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'

import store from '../store'

export default {
  name: 'login',
  store,
  data () {
    return {
      isSending: false,
      username: '',
      password: '',
      license: '',
      rememberMe: true,
      errors: {
        nonFieldErrors: [],
        username: [],
        password: [],
        license: [],
      },
    }
  },
  methods: {
    ...mapActions({
      login: 'account/login',
    }),
    submit () {
      this.login([this.username, this.password, this.license, this.rememberMe]).then(res => {
        if (this.rememberMe) {
          localStorage.setItem('licenseCode', this.license)
        }
        this.$router.push({name: 'Home'})
      }, err => {
        this.$err400(err)
      })
    },
  },
  mounted () {
    this.license = localStorage.getItem('licenseCode')
    $(this.$el).find('.txt')[0].focus()
  },
}
</script>

<style lang="scss" scoped>
#login {
  position: fixed;
  width: 300px;
  padding: 15px;
  top: 200px;
  left: 50%;
  margin-left: -150px;
  background-color: #F5F5F5;
  border-radius: 16px;
  box-shadow: 2px 2px 10px rgba(0,0,0,0.5);
  z-index: 100;

  fieldset {
    position: relative;
    display: block;
    padding: 0;
    border: none;

    #id_username {
      border-radius: 8px 8px 0 0;
    }

    input.txt {
      display: block;
      box-sizing: border-box;
      width: 100%;
      font-size: 16px;
      padding: 12px;
      margin: 0;
      border: 1px solid #DDD;
      border-bottom: none;
      line-height: 1;
    }
  }

  input#submit {
    box-sizing: border-box;
    width: 100%;
    padding: 6px 0;
    margin: 0;
    background-color: #FAFAFA;
    border: 1px solid #DDD;
    border-radius: 0 0 8px 8px;
    box-shadow: none;
    font-size: 16px;
    font-weight: bold;
    color: #777;
    cursor: pointer;

    &:active {
      background-color: #EEE;
      border: 1px solid #CCC;
      box-shadow: inset 0 1px 4px rgba(0,0,0,0.1);
    }
  }
  
  .error_msg_top {
    position: absolute;
    width: 280px;
    padding: 8px 10px;
    bottom: 105%;
    left: 50%;
    margin-left: -150px;
    background-color: rgba(255,255,255,0.95);
    border-radius: 4px;
    box-shadow: 1px 1px 1px rgba(0,0,0,0.2);
    font-size: 12px;
    font-weight: bold;
    color: #690;

    &:after {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(255, 255, 255, 0);
      border-top-color: rgba(255,255,255,0.95);
      border-width: 7px;
      margin-left: -7px;
    }
  }

  .error_msg {
    position: absolute;
    min-width: 240px;
    padding: 8px 10px;
    top: 4px;
    left: 102%;
    background-color: rgba(255,255,255,0.95);
    border-radius: 4px;
    box-shadow: 1px 1px 1px rgba(0,0,0,0.2);
    font-size: 12px;
    font-weight: bold;
    color: #690;

    &:after {
      right: 100%;
      top: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(255, 255, 255, 0);
      border-right-color: rgba(255, 255, 255, 0.95);
      border-width: 7px;
      margin-top: -7px;
    }
  }
}

#shade {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: 99;
}

#header {
  position: fixed;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 5px 0 0 0;
  background-color: #222528;
  box-shadow: 0 1px 0 rgba(0,0,0,0.1);
  text-align: center;
  z-index: 10;

  a.home {
    width: 140px;
    background-size: 122px 28px;
    left: 0;
    backgroud-image: url("/static/img/logo_kaleido.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue